import React from "react";
import { useNavigate } from "react-router-dom";
import '../styles/components.css';

const BottomSignupGradient = ({ type }) => {
    const navigate = useNavigate();
    const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
    const requestDemo = () => navigate("/demo");

    return (
        <section className='gradient-section'>
            <div>
                <button
                    className="rounded-button">
                    Interested?
                </button>
            </div>
            <h4>{type}</h4>
            <div>
                <button className='signup-button' onClick={freeSignUp}>Sign up for free</button>
                <button className='request-button' onClick={requestDemo}>Request Demo</button>
            </div>
        </section>

    );

};

export default BottomSignupGradient;